import { createContext } from "react";

export const COLOR_MODE_COOKIE_NAME = "nodiant-color-mode";
export const DEFAULT_COLOR_MODE = "light";

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export function getColorModePreference(cookieString) {
    const cookies =
        cookieString ??
        (typeof document === "undefined" ? "" : document.cookie);
    const preference = cookies
        .split(";")
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(`${COLOR_MODE_COOKIE_NAME}=`))
        ?.split("=")[1];

    return preference === "dark" ? "dark" : DEFAULT_COLOR_MODE;
}

export function saveColorModePreference(mode) {
    const safeMode = mode === "dark" ? "dark" : DEFAULT_COLOR_MODE;
    const secureAttribute =
        window.location.protocol === "https:" ? "; Secure" : "";

    document.cookie = `${COLOR_MODE_COOKIE_NAME}=${safeMode}; Max-Age=${ONE_YEAR_IN_SECONDS}; Path=/; SameSite=Lax${secureAttribute}`;
}

export const ColorModeContext = createContext({
    mode: DEFAULT_COLOR_MODE,
    setMode: () => {},
});
